import { Box, Typography, ButtonGroup, Button, Stack } from "@mui/material";
import { useState } from "react";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import { useTranslation } from "react-i18next";
import { useGetApiNotificationsAllQuery, usePostApiNotificationsMarkAsReadMutation } from "api/generatedApi";
import { useNavigate } from "react-router-dom";
import { NotificationItem } from "./notifications-components/notification-item";

export const NotificationsPage = () => {
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  const { screenSize } = useScreenSize();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: notificationData } = useGetApiNotificationsAllQuery({});
  const [markAsRead] = usePostApiNotificationsMarkAsReadMutation();

  const notifications = notificationData?.notifications ?? [];

  const handleClick = async (notificationIndex: number) => {
    await markAsRead({ markNotificationGroupAsReadRequest: notifications[notificationIndex] });
    navigate(`/projects/${notifications[notificationIndex].projectId}/dashboard/extraworkagreements`);
  };


  return (
    <Box sx={{ p: screenSize === ScreenSizeEnum.Mobile ? 1 : 3 }}>
      <Typography variant="h5" gutterBottom color="primary.main">
        {t("account.notifications.title")}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("account.notifications.description")}
      </Typography>
      <ButtonGroup sx={{ mb: 2 }}>
        <Button variant={showUnreadOnly ? "outlined" : "contained"} onClick={() => setShowUnreadOnly(false)}>
          {t("account.notifications.showAll")}
        </Button>
        <Button variant={showUnreadOnly ? "contained" : "outlined"} onClick={() => setShowUnreadOnly(true)}>
          {t("account.notifications.showUnread")}
        </Button>
      </ButtonGroup>

      <Box
        sx={{
          maxHeight: screenSize === ScreenSizeEnum.Mobile ? `calc(100vh - 285px)` : `calc(100vh - 250px)`,
          overflowY: "auto",
          width: "100%",
          pr: 2,
          py: 1,
        }}
      >
        <Stack spacing={2} minWidth={300}>
          {(notifications.filter(n => !showUnreadOnly || n.unreadNotificationCount).length === 0) && (
            <Typography variant="body2" color="text.secondary">
              {t("account.notifications.noNotifications")}
            </Typography>
          )}
          {notifications?.map((notification, idx) => {
            if (!showUnreadOnly || notification.unreadNotificationCount) {
              return <NotificationItem key={notification.projectId ?? idx} notification={notification} onClick={() => handleClick(idx)} />
            }
            return null;
          })}
        </Stack>
      </Box>
    </Box>
  );
};
